export interface StatusRequest {
  isLoading?: boolean;
  isPristine?: boolean;
  hasError?: boolean;
  hasSuccess?: boolean;

  message?: string;
}

export const initialStatus: StatusRequest = {
  isPristine: true,
  isLoading: false,
  hasError: false,
  hasSuccess: false,
};

export const loadingStatus: StatusRequest = {
  isPristine: false,
  isLoading: true,
  hasError: false,
  hasSuccess: false,
};

export const successStatus: StatusRequest = {
  isPristine: false,
  isLoading: false,
  hasError: false,
  hasSuccess: true,
};

export const failStatus: StatusRequest = {
  isPristine: false,
  isLoading: false,
  hasError: true,
  hasSuccess: false,
};
